define("shared/components/shared/post/profile-selector/available-profile/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @state.isAvailable}}
    <li class="u--m__b__xs qa--modal_available_profile">
      <Shared::Ui::Button
        @class={{concat-classes
          "cCP--list__item"
          (concat "is--p__" @profile.profileColorClass)
          (if @state.isSelected "is--selected")
        }}
        @onClick={{fn @toggleSelectProfile @state}}
        @variant="outline"
      >
        <Shared::ProfileAvatar
          @handleQaClass="qa--available_profile_username"
          @showDetails={{true}}
          @showOutline={{true}}
          @showPlatform={{true}}
          @socialProfile={{@profile}}
          aria-selected={{@state.isSelected}}
          class="cCA--user {{if @state.isSelected '' 'is--unselected'}}"
        />
        {{svg-jar "verified-solid" class="o--icon cCP--list__icon qa--modal_profile_addIcon"}}
      </Shared::Ui::Button>
    </li>
  {{/if}}
  */
  {
    "id": "6ImR13Ng",
    "block": "[[[41,[30,1,[\"isAvailable\"]],[[[1,\"  \"],[10,\"li\"],[14,0,\"u--m__b__xs qa--modal_available_profile\"],[12],[1,\"\\n    \"],[8,[39,1],null,[[\"@class\",\"@onClick\",\"@variant\"],[[28,[37,2],[\"cCP--list__item\",[28,[37,3],[\"is--p__\",[30,2,[\"profileColorClass\"]]],null],[52,[30,1,[\"isSelected\"]],\"is--selected\"]],null],[28,[37,4],[[30,3],[30,1]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],[[16,\"aria-selected\",[30,1,[\"isSelected\"]]],[16,0,[29,[\"cCA--user \",[52,[30,1,[\"isSelected\"]],\"\",\"is--unselected\"]]]]],[[\"@handleQaClass\",\"@showDetails\",\"@showOutline\",\"@showPlatform\",\"@socialProfile\"],[\"qa--available_profile_username\",true,true,true,[30,2]]],null],[1,\"\\n      \"],[1,[28,[35,6],[\"verified-solid\"],[[\"class\"],[\"o--icon cCP--list__icon qa--modal_profile_addIcon\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@state\",\"@profile\",\"@toggleSelectProfile\"],false,[\"if\",\"shared/ui/button\",\"concat-classes\",\"concat\",\"fn\",\"shared/profile-avatar\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/post/profile-selector/available-profile/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});